import { render, staticRenderFns } from "./ExtractionDossierJournalStatus.vue?vue&type=template&id=2339c635&scoped=true"
import script from "./ExtractionDossierJournalStatus.vue?vue&type=script&lang=js"
export * from "./ExtractionDossierJournalStatus.vue?vue&type=script&lang=js"
import style0 from "./ExtractionDossierJournalStatus.vue?vue&type=style&index=0&id=2339c635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339c635",
  null
  
)

export default component.exports